/* @flow */

import {
    ETAPA_PENDENTE,
    ETAPA_EXECUCAO,
    ETAPA_ENTREGA,
    ETAPA_FINALIZADO,
    ETAPA_CANCELADO,
    ETAPA_DEVOLVIDO,
} from '../pedidos/constants';

const MENSAGENS = {
    UTILS: {
        EXIBIR_ERRO: {
            TITULO: 'Desculpe!',
        },
        LOADING: {
            PADRAO: 'Aguarde...',
        },
        SUCESSO: {
            TITULO: 'Sucesso!',
        },
    },
    PRODUTOS: {
        CADASTRO: {
            PRECO_OBRIGATORIO: 'Preço obrigatório',
        },
    },
    EMPRESA: {
        TIPO_ARQUIVO_INVALIDO: {
            TITULO: 'Tipo do arquivo inválido.',
            TEXTO: 'Por favor selecione uma imagem.',
        },
        TIPO_ARQUIVO_INVALIDO_XLS: {
            TITULO: 'Tipo do arquivo inválido.',
            TEXTO: 'Por favor selecione apenas arquivos CSV (.csv).',
        },
        EDICAO: {
            SUCESSO: {
                TITULO: 'Estabelecimento editado!',
                TEXTO: '',
            },
        },
        RETIRADA: {
            SUCESSO: {
                TITULO: 'Opção de retirada no local editada!',
                TEXTO: '',
            },
        },
        ENDERECO: {
            EDICAO: {
                SUCESSO: {
                    TITULO: 'Endereço editado!',
                    TEXTO: '',
                },
            },
        },
        APLICATIVO: {
            NENHUMA_ALTERACAO: 'Nenhuma alteração.',
            UPLOAD: {
                IMAGEM_FUNDO: {
                    ERRO: 'Não foi possível enviar a imagem de fundo.',
                },
                LOGO: {
                    ERRO: 'Não foi possível enviar o logo.',
                },
            },
            EDICAO: {
                SUCESSO: {
                    TITULO: 'Aplicativo editado!',
                    TEXTO: '',
                },
            },
        },
        CONTATOS: {
            EDICAO: {
                SUCESSO: {
                    TITULO: 'Contatos editados!',
                    TEXTO: '',
                },
            },
        },
        IMPRESSORAS: {
            EDICAO: {
                SUCESSO: {
                    TITULO: 'Configuração de impressão editada!',
                    TEXTO: '',
                },
            },
        },
        PAGAMENTO: {
            EDICAO: {
                SUCESSO: {
                    TITULO: 'Configurações de pagamento online editadas!',
                    TEXTO: '',
                },
            },
        },
    },
    PAGSEGURO: {
        SALVAR: {
            SUCESSO: 'Pagseguro salvo!',
        },
        VALIDAR_DADOS: {
            SUCESSO: 'Dados da válidos!',
            ERRO: 'Dados inválidos.',
        },
    },
    VOUCHER: {
        VALIDACAO: {
            TITULO_PADRAO: 'Atenção!',
            DATA_ANTERIOR_INICIAL: {
                TEXTO: 'A data final não pode ser anterior a data inicial!',
            },
            DATA_ANTERIOR_ATUAL: {
                TEXTO: 'A data final não pode ser anterior a data atual!',
            },
            VALOR_ZERADO: {
                TEXTO: 'O valor do voucher precisa ser maior que 0!',
            },
            CODIGO: {
                TEXTO: 'O nome promocional deve conter pelo menos um caracter',
            },
            VALOR_MINIMO: {
                TEXTO: 'O valor mínimo deve ser maior que o valor do voucher',
            },
        },
    },
    REDEFINIR_SENHA: {
        CONFIRMACAO_SENHA: {
            TITULO: 'Opss...',
            TEXTO: 'A confirmação de senha não coincide com a senha digitada',
        },
        SUCESSO: {
            TITULO: 'Parabéns!',
            TEXTO: 'Senha atualizada com sucesso!',
        },
    },
    COMPLEMENTOS: {
        ATUALIZAR_PRECO: {
            SUCESSO: 'Preço alterado com sucesso!',
        },
    },
    CATEGORIAS: {
        ORDENACAO_VAZIA: 'Nenhuma categoria para ordenar.',
    },
    APLICATIVO: {
        ATIVACAO: {
            SUCESSO: {
                TITULO: '',
                TEXTO: 'Aplicativo disponível para vendas',
            },
        },
        DESATIVACAO: {
            SUCESSO: {
                TITULO: '',
                TEXTO: 'As vendas via aplicativo foram encerradas',
            },
        },
    },
    ATENDIMENTO: {
        LOADING_INICIAL: 'Carregando pedidos...',
        SEM_PEDIDOS: {
            NENHUM: 'Não existe pedidos nas últimas 24 horas',
            [ETAPA_PENDENTE]: 'Não existe pedidos pendentes nas últimas 24 horas',
            [ETAPA_EXECUCAO]: 'Não existe pedidos em execução nas últimas 24 horas',
            [ETAPA_ENTREGA]: 'Não existe pedidos em entrega nas últimas 24 horas',
            [ETAPA_FINALIZADO]: 'Não existe pedidos finalizados nas últimas 24 horas',
            [ETAPA_CANCELADO]: 'Não existe pedidos cancelados nas últimas 24 horas',
            [ETAPA_DEVOLVIDO]: 'Não existe pedidos devolvidos nas últimas 24 horas',
        },
    },
    VALOR_MINIMO: {
        SALVAR: {
            SUCESSO: 'Configuração atualizada com sucesso',
        },
    },
    TOKEN_IMPRESSORAS: {
        CONFIRMAÇÃO: {
            TITULO: 'Deseja gerar nova chave?',
            TEXTO: 'As impressoras terão de ser configuradas para a nova chave. Deseja continuar?',
        },
    },
    RELATORIOS: {
        LOADING: 'Carregando...',
    },
    USUARIO: {
        SENHA: {
            CONFIRMA_SENHA: {
                TEXTO: 'Os campos de senhas não estão iguais. Favor, digite novamente!',
            },
            SUCESSO: {
                TEXTO: 'Sua senha foi alterada com sucesso!',
            },
        },
    },
};

export default MENSAGENS;
